import { render, staticRenderFns } from "./MembersByGrade.vue?vue&type=template&id=2b3dab20"
import script from "./MembersByGrade.vue?vue&type=script&lang=js"
export * from "./MembersByGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports